/**
 * HHT2 TimeLine Contents 정보
 * @type {string[]}
 */

export const HHT2_EP9_ANSWERS = [
    'Matt and the kids are in a fast-food restaurant. Matt asks, “What would you like to order, kids?”',
    'First, Holly orders a chicken burger with large French fries, a Coke, and no onions.',
    'Then, Tony orders a chicken burger with no onions.',
    'Finally, Harry orders a double cheeseburger with a Coke and no onions.',
    'Matt tells the kids to go find a table.',
    'When Matt brings the food, the kids realize they all have onions in their burgers! Matt says, “Vegetables are good for your health!”',
    'But the kids plan something. They bump the table and spill some water.',
    'When Matt goes to get napkins, Holly says, “Let’s put the onions in Dad’s burger!”',
    'When Matt comes back and eats his burger, he is shocked because of all the onions!',
    'The kids laugh. Harry says, “Vegetables are good for your health!”',
];

// export const HHT2_EP9_ANSWER_SOUNDS = [
//     '/HHT2_AB EP09_dyr01.mp3',
//     '/HHT2_AB EP09_dyr02.mp3',
//     '/HHT2_AB EP09_dyr03.mp3',
//     '/HHT2_AB EP09_dyr04.mp3',
//     '/HHT2_AB EP09_dyr05.mp3',
//     '/HHT2_AB EP09_dyr06.mp3',
//     '/HHT2_AB EP09_dyr07.mp3',
//     '/HHT2_AB EP09_dyr08.mp3',
//     '/HHT2_AB EP09_dyr09.mp3',
//     '/HHT2_AB EP09_dyr10.mp3',
// ];

export const HHT2_EP9_ANSWER_SOUNDS = [
    '/ba1cedba064fb467041eeeec63b2aeea.mp3',
    '/5bb127e26eeae0e720ebeb317597c5f8.mp3',
    '/dff52f4284731c77535889b55f731f75.mp3',
    '/7b5bb1c0e913eed43e7362c1bb8054b7.mp3',
    '/ee27727457058b6f213f67843cd40861.mp3',
    '/865508002b2a1d8d77159f15087d2364.mp3',
    '/cb7d3725491d14c11a97fff943b5a075.mp3',
    '/0216334f0637bfa7e6f1f454bc6584f2.mp3',
    '/6fa6ffd119af30a7a79e49ef090a8220.mp3',
    '/1c421c3fe9b5c7c39b5eba26c040d015.mp3',
];

export const HHT2_EP9_QUIZ_ITEMS = [{
    'A': HHT2_EP9_ANSWERS[1],
    'B': HHT2_EP9_ANSWERS[6],
    'SoundIndexA': 1,
    'SoundIndexB': 6,
    'answer': HHT2_EP9_ANSWERS[1],
    'sound': [2, 3],
    'exception': false,
},
    {
        'A': HHT2_EP9_ANSWERS[8],
        'B': HHT2_EP9_ANSWERS[4],
        'SoundIndexA': 8,
        'SoundIndexB': 4,
        'answer': HHT2_EP9_ANSWERS[4],
        'sound': [5, 6],
        'exception': false,
    },
    {
        'A': HHT2_EP9_ANSWERS[7],
        'B': HHT2_EP9_ANSWERS[2],
        'SoundIndexA': 7,
        'SoundIndexB': 2,
        'answer': HHT2_EP9_ANSWERS[7],
        'sound': [8],
        'exception': false,
    },
    {
        'A': HHT2_EP9_ANSWERS[3],
        'B': HHT2_EP9_ANSWERS[9],
        'SoundIndexA': 3,
        'SoundIndexB': 9,
        'answer': HHT2_EP9_ANSWERS[9],
        'sound': [9],
        'exception': false,
    },
]
